export const GET_STOCK = 'GET_STOCK'
export const GET_STOCK_SUCCESS = 'GET_STOCK_SUCCESS'
export const GET_STOCK_ERROR = 'GET_STOCK_ERROR'

export interface Stock {
  list: { codigo: string; cantidad: number }[]
  paisId: number
}
export interface StockState {
  stock: Stock[] | null
  loading: boolean
  error: boolean
}
export const initialState: StockState = {
  stock: null,
  loading: false,
  error: false,
}
export interface GetStock {
  type: typeof GET_STOCK
  payload: null
}
export interface GetStockSuccess {
  type: typeof GET_STOCK_SUCCESS
  payload: Stock
}
export interface GetStockError {
  type: typeof GET_STOCK_ERROR
  payload: boolean
}

export type StockActions = GetStock | GetStockSuccess | GetStockError
